import {
  GetHeroComponentDocument,
  GetHeroComponentQuery,
  GetHeroComponentQueryVariables,
  Scalars,
} from 'generated/graphql';
import { client } from './client';
import { getLocalesForGraphQL } from '../utils/helpers';

export async function getHeroComponent(id: string, locale: string) {
  return client.query<GetHeroComponentQuery, GetHeroComponentQueryVariables>({
    query: GetHeroComponentDocument,
    variables: {
      locales: getLocalesForGraphQL(locale),
      where: {
        id,
      },
    },
  });
}
